var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36271 4.42521C8.54576 4.24215 8.54576 3.94535 8.36271 3.76229C8.17965 3.57924 7.88285 3.57924 7.69979 3.76229L5.21875 6.24334L4.30021 5.32479C4.11715 5.14174 3.82035 5.14174 3.63729 5.32479C3.45424 5.50785 3.45424 5.80465 3.63729 5.98771L4.88729 7.23771C5.07035 7.42076 5.36715 7.42076 5.55021 7.23771L8.36271 4.42521Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.5C1 2.73858 3.23858 0.5 6 0.5C8.76142 0.5 11 2.73858 11 5.5C11 8.26142 8.76142 10.5 6 10.5C3.23858 10.5 1 8.26142 1 5.5ZM1.9375 5.5C1.9375 3.25634 3.75634 1.4375 6 1.4375C8.24366 1.4375 10.0625 3.25634 10.0625 5.5C10.0625 7.74366 8.24366 9.5625 6 9.5625C3.75634 9.5625 1.9375 7.74366 1.9375 5.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36271 4.42521C8.54576 4.24215 8.54576 3.94535 8.36271 3.76229C8.17965 3.57924 7.88285 3.57924 7.69979 3.76229L5.21875 6.24334L4.30021 5.32479C4.11715 5.14174 3.82035 5.14174 3.63729 5.32479C3.45424 5.50785 3.45424 5.80465 3.63729 5.98771L4.88729 7.23771C5.07035 7.42076 5.36715 7.42076 5.55021 7.23771L8.36271 4.42521Z",
    stroke: "white",
    strokeWidth: 0.153846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.5C1 2.73858 3.23858 0.5 6 0.5C8.76142 0.5 11 2.73858 11 5.5C11 8.26142 8.76142 10.5 6 10.5C3.23858 10.5 1 8.26142 1 5.5ZM1.9375 5.5C1.9375 3.25634 3.75634 1.4375 6 1.4375C8.24366 1.4375 10.0625 3.25634 10.0625 5.5C10.0625 7.74366 8.24366 9.5625 6 9.5625C3.75634 9.5625 1.9375 7.74366 1.9375 5.5Z",
    stroke: "white",
    strokeWidth: 0.153846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.1ec77a91fd77783a0541b11981102c95.svg";
export { ForwardRef as ReactComponent };